import {
  convertCooldown,
  Priorities,
  getSampleCompare,
} from '@components/dimensions-panel/DiagnosticsChartCard/EventDetail/EventDetail';
import { getMetricInfo } from '@src/pages/Alert/manualAlert/constants';
import { METRIC_TO_ALERT_METRIC_MAPPING } from '@utils/aiAlerts/alertMetrics';
import { convertValue } from '@src/pages/Alert/manualAlert/shared';
import { get } from 'lodash';
import moment from 'moment';
import { EVENT_DT_FORMAT } from '@utils/constants';

// some of the parsing is a copy of manual alert diag saga
// TODO: the metric formatting should move to IF server
export const parseAlert = (alert, isBusinessMetricsEnabled = true) => {
  const { metric: _metric } = alert;

  const metric = Object.entries(METRIC_TO_ALERT_METRIC_MAPPING(isBusinessMetricsEnabled)).filter(
    ([, alertMetric]) => alertMetric === _metric,
  )[0][0];

  const metricsInfo = getMetricInfo();
  const _cmMetric = metricsInfo[_metric].cm_metric;
  const cmMetric = get(
    Object.entries(METRIC_TO_ALERT_METRIC_MAPPING(isBusinessMetricsEnabled)).filter(
      ([, alertMetric]) => alertMetric === _cmMetric,
    ),
    '0.0',
    null,
  );

  return {
    ...alert,
    // mapped
    metric,
    cmMetric,
    // raw
    _metric,
    _cmMetric,
  };
};

const parseAlerts = (alerts, isBusinessMetricsEnabled = true) => {
  const alertsMap: any = {};
  Object.values(alerts).forEach((alert: any) => {
    alertsMap[alert.id] = parseAlert(alert);
  });
  return alertsMap;
};

export const formatResponse = (data) => {
  const { events = [], alerts = {} } = data;

  const alertsMap = parseAlerts(alerts);
  const eventsByMetrics = {};

  events.forEach((event) => {
    const alert = alertsMap[event.alertId];
    if (alert.metric in eventsByMetrics) {
      eventsByMetrics[alert.metric].push(event);
    } else {
      eventsByMetrics[alert.metric] = [event];
    }
  });

  return {
    eventsByMetrics,
    alerts: alertsMap,
    events,
  };
};

export const createAlertSummary = (event, alert) => {
  const metricsInfo = getMetricInfo();
  const hideAlertInfo = moment(alert.changedAt).isAfter(event.time);
  const metricInfo = metricsInfo[alert._metric]; // alert metric key

  let condition = {};
  if (hideAlertInfo) {
    condition = {
      rule: `${convertValue(event.value, metricInfo.units)} ${metricInfo.units} `,
      threshold: `${event.samples} ${metricInfo.cm_label}`,
    };
  } else {
    condition = {
      rule: `${convertValue(event.value, metricInfo.units)} ${alert.direction} ${convertValue(alert.threshold, metricInfo.units)} ${metricInfo.units}`,
      threshold: `${event.samples} ${getSampleCompare(event.samples, alert.samples)} ${alert.samples} ${metricInfo.cm_label}`,
    };
  }

  return {
    name: alert.name,
    filterName: alert.filter.name,
    timeRange: `${moment(event.time).subtract(event.window, 'minutes').format('HH:mm')} - ${moment(event.time).format(EVENT_DT_FORMAT)}`,
    cooldown: convertCooldown(alert.cooldown),
    priority: Priorities[alert.priority],
    metric: alert.metric,
    ...condition,
  };
};

export const buildEventHeatMap = (alert) => {
  const eventCount = {};

  alert.events.forEach((event) => {
    const day = moment(event.time).format('YYYY-MM-DD');
    if (day in eventCount) {
      eventCount[day]++;
    } else {
      eventCount[day] = 1;
    }
  });

  return Object.entries(eventCount);
};
